import { combineReducers } from 'redux';

import { IMPORT_SOURCE } from 'modules/tireScan/constants';

import error from './error';
import hasMore from './hasMore';
import ids from './ids';
import loading from './loading';

const source = IMPORT_SOURCE.MODAL;

export default combineReducers({
  modal: combineReducers({
    ids: ids(source),
    error: error(source),
    hasMore: hasMore(source),
    loading: loading(source),
  }),
});
